import { salesApiInstance } from './client.js';

export const rolesApi = {
  getAll:         (params = {}) => salesApiInstance.get('/roles', { params }).then(r => r.data),
  getMatrix:      ()            => salesApiInstance.get('/roles/matrix').then(r => r.data),
  getPermissions: ()            => salesApiInstance.get('/roles/permissions').then(r => r.data),
  getById:        (id)          => salesApiInstance.get(`/roles/${id}`).then(r => r.data),
  create:         (payload)     => salesApiInstance.post('/roles', payload).then(r => r.data),
  update:         (id, payload) => salesApiInstance.put(`/roles/${id}`, payload).then(r => r.data),
  remove:         (id)          => salesApiInstance.delete(`/roles/${id}`).then(r => r.data),
};
